import http from './http';

/**
 * Solicita la eliminación de cuenta de un cliente de la app.
 *
 * TODO: Confirmar ruta y contrato con el backend.
 *
 * POST /clients/account-deletion
 * Body: { email: string }
 *
 * Respuestas esperadas:
 * - 200: { message: "Cuenta eliminada correctamente" }
 * - 401/422: credenciales inválidas o cuenta inexistente
 * - 403: cuenta no eliminable (restricciones activas)
 */
export const requestAccountDeletion = async ({ email }) => {
  const response = await http.post('/clients/account-deletion', { email });
  return response.data?.data ?? response.data;
};

/**
 * Confirma la eliminación de cuenta con el código recibido por correo.
 *
 * POST /clients/account-deletion/confirm
 * Body: { code: string }
 */
export const confirmAccountDeletion = async ({ code }) => {
  const response = await http.post(
    '/clients/account-deletion/confirm',
    { code },
    { skipAuthRedirect: true },
  );
  return response.data?.data ?? response.data;
};

const accountDeletionService = {
  requestAccountDeletion,
  confirmAccountDeletion,
};

export default accountDeletionService;
